module.exports = __webpack_public_path__ + "img/num_34.b9fe09a1.png";